import { toProseMirror } from "./mdast-util-to-prosemirror.js";
export { toPmNode, toPmMark } from "./mdast-util-to-prosemirror.js";
export const remarkProseMirror = function(options) {
    this.compiler = function(tree) {
        return toProseMirror(tree, options);
    };
};
